// Import all ts files here
import '../styles/index.scss';
import './templates/cart';
import { docReady } from './helpers/docReady';
import { carousel } from './sections/carousel';
import { greensparkAPI } from './sections/greenspark';
import { splitImages } from './sections/split-images-with-text';
// Custom element — self-registers on import, no docReady hook needed.
import './sections/popup-cascade';
docReady(() => {
    // Initiate JS
    carousel();
    greensparkAPI();
    splitImages();
});
